<template>
  <div class="container px-0 mb-2">
    <CardRoot class="border-translucent">
      <CardHeader>
        <CardTitle>{{ company.name }}</CardTitle>
      </CardHeader>
      <CardBody class="pt-0">
        <TeamComponent v-if="company.id" :company_id="company.id" :company />
      </CardBody>
    </CardRoot>
  </div>
</template>

<script setup lang="ts">
import {
  CardBody,
  CardHeader,
  CardRoot,
  CardTitle,
} from "@/components/common/card";
import TeamComponent from "@/dashboard/settings_management/TeamComponent.vue";
import type { Company } from "@/types";

// EKOenergy-portal company page: team management only. The producer settings
// (VAT, bank, billing email, registry devices) are Soldera workflows and stay
// on app.soldera.org.
defineProps<{
  company: Company;
}>();
</script>
